import React from 'react';
import { Helmet } from 'react-helmet-async';
export function FAQsPage() {
  return <>
      <Helmet data-id="element-182">
        <title data-id="element-183">FAQs - Early Warning Report</title>
        <meta name="description" content="Frequently Asked Questions about the Early Warning Report Service" data-id="element-184" />
      </Helmet>
      <section className="w-full bg-white text-secondary-800 text-base leading-7 font-sans rounded-xl shadow-2xl overflow-hidden" data-id="element-185">
        <div className="bg-gradient-to-br from-primary-700 via-primary-600 to-primary-800 text-white py-16 px-8 relative overflow-hidden" data-id="element-186">
          <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&q=80')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }} data-id="element-187"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-primary-900/20 to-transparent" data-id="element-188"></div>
          <div className="relative z-10" data-id="element-189">
            <h1 className="font-display text-4xl md:text-6xl font-bold mb-6 text-center leading-tight" data-id="element-190">
              Frequently Asked Questions
            </h1>
            <p className="text-center text-xl md:text-2xl max-w-3xl mx-auto text-primary-50 font-medium" data-id="element-191">
              Everything you need to know about the Early Warning Report Service
            </p>
          </div>
        </div>
        <div className="px-8 py-12 max-w-6xl mx-auto" data-id="element-192">
          <div className="space-y-6" data-id="element-193">
            <div className="bg-white rounded-lg shadow-sm border border-secondary-200 overflow-hidden" data-id="element-194">
              <div className="p-5 border-b border-secondary-200" data-id="element-195">
                <h3 className="font-display text-lg font-bold text-primary-700 flex items-center" data-id="element-196">
                  <span className="flex-shrink-0 flex items-center justify-center bg-primary-600 text-white rounded-full w-6 h-6 mr-3 text-sm" data-id="element-197">
                    1
                  </span>
                  Who is Behind Early Warning Report and Why Should We Trust It?
                </h3>
              </div>
              <div className="p-5 text-secondary-700" data-id="element-198">
                Great question! The Early Warning Report Service was founded by
                Ray King and Marc Trachtenberg who have a proven track record of
                domain name industry experience and success. Ray is the CEO of
                Top Level Design, which acquired a number of popular new gTLDs
                in the first round and after, and later sold them all. He is
                also the CEO of Porkbun, one of the largest domain registrars,
                which just surpassed 3 million domains under management. Marc is
                an attorney who specializes in internet and domain name matters.
                He has been actively involved in ICANN for over 20 years and
                represents registries, registrars, search engines, eCommerce
                platforms, social media companies, and other online
                intermediaries. He is also counsel to the Brand Registry Group,
                which is the leading trade association for owners of .Brand
                TLDs. Marc participated in the policy development process for
                the first round of new gTLDs in 2015 and assisted with dozens of
                new gTLD applications in that round. He later assisted in
                numerous TLD acquisitions on the buy and sell sides and
                participated also in the the policy development process for the
                upcoming round of new gTLD applications.
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-secondary-200 overflow-hidden" data-id="element-199">
              <div className="p-5 border-b border-secondary-200" data-id="element-200">
                <h3 className="font-display text-lg font-bold text-primary-700 flex items-center" data-id="element-201">
                  <span className="flex-shrink-0 flex items-center justify-center bg-primary-600 text-white rounded-full w-6 h-6 mr-3 text-sm" data-id="element-202">
                    2
                  </span>
                  How Much Does the Early Warning Report Service Cost?
                </h3>
              </div>
              <div className="p-5 text-secondary-700" data-id="element-203">
                The cost for participation in the Pre-Application Early Warning
                Report is $1,000 per string. The cost for participation in the
                Post-Application Early Warning Report is $3,000 per string.
                Participants in the Pre-Application Early Warning Report will
                only be charged $2,000 per string in the Post-Application Early
                Warning Report for strings they previously submitted.
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-secondary-200 overflow-hidden" data-id="element-204">
              <div className="p-5 border-b border-secondary-200" data-id="element-205">
                <h3 className="font-display text-lg font-bold text-primary-700 flex items-center" data-id="element-206">
                  <span className="flex-shrink-0 flex items-center justify-center bg-primary-600 text-white rounded-full w-6 h-6 mr-3 text-sm" data-id="element-207">
                    3
                  </span>
                  Can You Guarantee That Early Warning Report Will Identify All
                  Conflicting Strings in the Next Round?
                </h3>
              </div>
              <div className="p-5 text-secondary-700" data-id="element-208">
                No, unless every potential applicant participates this is not
                possible. But even if only some applicants participate, those
                who do will have more information and a competitive advantage.
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-secondary-200 overflow-hidden" data-id="element-209">
              <div className="p-5 border-b border-secondary-200" data-id="element-210">
                <h3 className="font-display text-lg font-bold text-primary-700 flex items-center" data-id="element-211">
                  <span className="flex-shrink-0 flex items-center justify-center bg-primary-600 text-white rounded-full w-6 h-6 mr-3 text-sm" data-id="element-212">
                    4
                  </span>
                  What if Participants Don't Submit All of Their Intended or
                  Applied-For Strings?
                </h3>
              </div>
              <div className="p-5 text-secondary-700" data-id="element-213">
                This is possible but there is no incentive for participants to
                do this as they would only be depriving themselves of valuable
                data points. For the Post-Application Report we will be doing
                some measure of verification.
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-secondary-200 overflow-hidden" data-id="element-214">
              <div className="p-5 border-b border-secondary-200" data-id="element-215">
                <h3 className="font-display text-lg font-bold text-primary-700 flex items-center" data-id="element-216">
                  <span className="flex-shrink-0 flex items-center justify-center bg-primary-600 text-white rounded-full w-6 h-6 mr-3 text-sm" data-id="element-217">
                    5
                  </span>
                  Does the Early Warning Report Violate ICANN Rules for the Next
                  Round?
                </h3>
              </div>
              <div className="p-5 text-secondary-700" data-id="element-218">
                No. The rules for the next round prohibit sharing information
                and private resolution of contention sets{' '}
                <strong className="font-bold" data-id="element-219">
                  <em data-id="element-220">after Reveal Day</em>
                </strong>
                . The Early Warning Report Service operates outside the
                application process and ends{' '}
                <strong className="font-bold" data-id="element-221">
                  <em data-id="element-222">before Reveal Day</em>
                </strong>
                .
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-secondary-200 overflow-hidden" data-id="element-223">
              <div className="p-5 border-b border-secondary-200" data-id="element-224">
                <h3 className="font-display text-lg font-bold text-primary-700 flex items-center" data-id="element-225">
                  <span className="flex-shrink-0 flex items-center justify-center bg-primary-600 text-white rounded-full w-6 h-6 mr-3 text-sm" data-id="element-226">
                    6
                  </span>
                  What if I don't Participate in the Early Warning Report?
                </h3>
              </div>
              <div className="p-5 text-secondary-700" data-id="element-227">
                There is no requirement to participate, but not participating
                may put you at a competitive disadvantage to other applicants
                who will have more information available to them enabling them
                to make strategic decisions before they are locked into the
                ICANN process and must forfeit significant amounts of their
                application investment if they withdraw or lose at auction.
                Think of it as cheap insurance to protect your potential
                application investment.
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-secondary-200 overflow-hidden" data-id="element-228">
              <div className="p-5 border-b border-secondary-200" data-id="element-229">
                <h3 className="font-display text-lg font-bold text-primary-700 flex items-center" data-id="element-230">
                  <span className="flex-shrink-0 flex items-center justify-center bg-primary-600 text-white rounded-full w-6 h-6 mr-3 text-sm" data-id="element-231">
                    7
                  </span>
                  Is the Early Warning Report System Secure?
                </h3>
              </div>
              <div className="p-5 text-secondary-700" data-id="element-232">
                Yes! A neutral and trusted intermediary will be used to ensure
                the security, integrity, and confidentiality of all strings
                submitted to the Early Warning Report Service and who submitted
                them.
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-secondary-200 overflow-hidden" data-id="element-233">
              <div className="p-5 border-b border-secondary-200" data-id="element-234">
                <h3 className="font-display text-lg font-bold text-primary-700 flex items-center" data-id="element-235">
                  <span className="flex-shrink-0 flex items-center justify-center bg-primary-600 text-white rounded-full w-6 h-6 mr-3 text-sm" data-id="element-236">
                    8
                  </span>
                  Who Will Have Access to the Data in the Early Warning System?
                </h3>
              </div>
              <div className="p-5 text-secondary-700" data-id="element-237">
                The only people with access to the data will be the trusted
                third party intermediary. Not even the principals or staff of
                the Early Warning Report will have access.
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-secondary-200 overflow-hidden" data-id="element-238">
              <div className="p-5 border-b border-secondary-200" data-id="element-239">
                <h3 className="font-display text-lg font-bold text-primary-700 flex items-center" data-id="element-240">
                  <span className="flex-shrink-0 flex items-center justify-center bg-primary-600 text-white rounded-full w-6 h-6 mr-3 text-sm" data-id="element-241">
                    9
                  </span>
                  How will you handle string similarity?
                </h3>
              </div>
              <div className="p-5 text-secondary-700" data-id="element-242">
                The trusted third party intermediary will follow ICANN's string
                similarity rules when creating Early Warning Report contention
                sets.
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-secondary-200 overflow-hidden" data-id="element-243">
              <div className="p-5 border-b border-secondary-200" data-id="element-244">
                <h3 className="font-display text-lg font-bold text-primary-700 flex items-center" data-id="element-245">
                  <span className="flex-shrink-0 flex items-center justify-center bg-primary-600 text-white rounded-full w-6 h-6 mr-3 text-sm" data-id="element-246">
                    10
                  </span>
                  What if there are very few participants?
                </h3>
              </div>
              <div className="p-5 text-secondary-700" data-id="element-247">
                All fees will be refunded if a threshold of 200 strings are not
                submitted for the Pre-Application Early Warning Report.
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}